import { render, staticRenderFns } from "./login_register.vue?vue&type=template&id=231b155f&scoped=true&"
import script from "./login_register.vue?vue&type=script&lang=js&"
export * from "./login_register.vue?vue&type=script&lang=js&"
import style0 from "./login_register.vue?vue&type=style&index=0&id=231b155f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231b155f",
  null
  
)

export default component.exports